import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { Row } from 'write-excel-file';

import type { WidgetExportOptions } from 'src/components/dashboard/DashboardPage/components/WidgetFrame/useWidgetExport';
import type { Filter } from 'src/components/dashboard/hooks/useWidgetFilterConfig';
import type { AggregateList } from 'src/components/followUp/common/types';

type UseExportOptionsProps = {
  data?: AggregateList;
  filters: Filter;
} & Pick<WidgetExportOptions, 'widgetName' | 'queryFilters'>;

export const useExportOptions = ({
  data,
  filters,
  widgetName,
  queryFilters,
}: UseExportOptionsProps): WidgetExportOptions => {
  const { t } = useTranslation('followUp');

  return useMemo(() => {
    const rows: Row[] = [
      [
        {
          value: filters.time_step
            ? t(
                `statistics.npsTrendAnalysisWidget.timeStep.${filters.time_step}`,
              )
            : 'Date',
          fontWeight: 'bold',
        },
      ],
      ...(data?.results || []).map((result) => [
        {
          value: result.label,
        },
        {
          value: result.value,
        },
      ]),
    ];

    return {
      widgetName: widgetName,
      rows,
      queryFilters,
    };
  }, [data, filters, queryFilters, widgetName, t]);
};
